import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

/**
 * Attaches the OIDC bearer token to outbound API requests only. Non-API requests
 * (static assets) are left untouched. The token is never logged (SECURITY-01/03).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Guard against an empty/undefined API_URL: `startsWith('')` is always true, so a
  // missing API_URL would attach the bearer token to EVERY outbound request —
  // including third-party hosts — leaking the OIDC token (SECURITY-01/03).
  const apiUrl = environment.API_URL;
  if (!apiUrl || !req.url.startsWith(apiUrl)) {
    return next(req);
  }

  const token = inject(OAuthService).getAccessToken();
  if (!token) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
